<template>
  <div class="passwdSet_main">
    <div class="systemSet" v-loading="$store.state.loading">
      <div class="titleBox">
        <span>密码设置</span>
      </div>

      <el-divider></el-divider>
      <div style="overflow: auto">
        <div style="display: flex">
        
          <div class="head" style="padding-left: 13.5rem;padding-top: 5rem;">
            <el-form
              label-position="left"
              label-width="7rem"
              :model="ruleForm"
              style="display: flex"
              :rules="rules"
              ref="ruleForm"
            >
              <div style="width: 25.625rem">
                <el-form-item label="当前账号：">
                  <el-input disabled v-model="ruleForm.name"></el-input>
                </el-form-item>
                <el-form-item label="旧 密 码：" prop="oldpasswd">
                  <el-input
                    type="password"
                    v-model="ruleForm.oldpasswd"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
                <el-form-item label="新 密 码：" prop="newpasswd">
                  <el-input
                    type="password"
                    v-model="ruleForm.newpasswd"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
                <el-form-item label="确认新密码：" prop="checkpasswd">
                  <el-input
                    type="password"
                    v-model="ruleForm.checkpasswd"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
              </div>
            </el-form>
            <div style="margin-left: 6.575rem">
              <button
                class="btn3"
                :disabled="
                  ruleForm.checkpasswd === '' ||
                  ruleForm.newpasswd === '' ||
                  ruleForm.oldpasswd === '' ||
                  ruleForm.newpasswd != ruleForm.checkpasswd
                "
                @click="changePassword('ruleForm')"
              >
                确定
              </button>
              <button
                style="margin-left: 0.625rem"
                class="btn4"
                @click="resetForm('ruleForm')"
              >
                取消
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
// import Pagination from "../../components/Pagination.vue";
export default {
  components: {},
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("新密码不能为空"));
      } else {
        if (this.ruleForm.checkpasswd !== "") {
          this.$refs.ruleForm.validateField("checkpasswd");
        }
        callback();
      }
    };
    var validatePass3 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("旧密码不能为空"));
      } else {
        if (this.ruleForm.oldpasswd !== "") {
          this.$refs.ruleForm.validateField("oldpasswd");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.newpasswd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      pageNo: 1,
      pageSize: 10,
      total: 0,
      activeNames: ["0"],
      ruleForm: {
        name: window.sessionStorage.getItem('username')?window.sessionStorage.getItem('username'):'',
        region: "",
        oldpasswd: "",
        newpasswd: "",
        checkpasswd: "",
      },
      rules: {
        newpasswd: [{ validator: validatePass, trigger: "blur" }],
        oldpasswd: [{ validator: validatePass3, trigger: "blur" }],
        checkpasswd: [{ validator: validatePass2, trigger: "blur" }],
      },
      options: [
        {
          value: "选项1",
          label: "重要",
        },
        {
          value: "选项2",
          label: "不重要",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // submitForm(formName) {
    //     this.$refs[formName].validate((valid) => {
    //       if (valid) {
    //           console.log(123);
    //       } else {
    //         console.log('error submit!!');
    //         return false;
    //       }
    //     });
    //   },
    changePassword(formName) {
      console.log(this.$refs[formName].validate);
      const params = {
        newPassword: this.ruleForm.newpasswd,
        oldPassword: this.ruleForm.oldpasswd,
      };
      this.$api.user.changePassword(params).then((res) => {
        if (res.code == 200) {
          this.$alert('密码修改成功', "", {
            confirmButtonText: "确定",
            type: "success",
            center: true,
          });
        } else {
          this.$alert(res.msg, "", {
            confirmButtonText: "确定",
            type: "warning",
            center: true,
          });
        }
      });
    },
    handleChange(val) {
      console.log(val);
    },
    tableRowClassName({ row, rowIndex }) {
      //配置表格行的index
      row.index = rowIndex;
    },
  },
  computed: {},
};
</script>
  
<style lang="less" scoped>
.passwdSet_main{
  width: 100%;
  height: 100%;
  font-size: 1.5rem;
  z-index: 15;
  overflow: auto;
  box-sizing: border-box;
  display: flex;
}
.systemSet {
  background: var(--cardbg-color);
width: 100%;
height: 100%;
  /deep/.el-form-item__content {
    display: flex;
    align-items: center;
  }
  /deep/ .el-input.is-disabled .el-input__inner {
    width: 16.25rem;
    height: 2.6875rem;
    background: #64999f27;
    border: 0.125rem solid #244447;
    border-radius: 0rem;
    color: #ffffff;
    font-size: 1rem !important;
  }
  /deep/.el-collapse-item__header {
    width: 5.3125rem !important;
    font-size: 0.875rem !important;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN !important;
    font-weight: 400 !important;
    color: #5bb3bc !important;
    line-height: 0.875rem !important;
  }
  .text {
    font-size: 1.75rem;
    font-weight: bold;
    color: #ffffff;
  }

  /deep/.el-divider {
    background-color: #244447;
    margin-top: 1rem;
    margin-bottom: 0.9375rem;
  }

  .Table {
    width: 99%;
    background-color: transparent;
    .text2 {
      cursor: pointer;
      border-bottom: 0.0625rem solid;
      padding-bottom: 0.0625rem;
    }
  }
}
.head {
  /deep/ .el-form-item {
    margin-bottom: 1.25rem;
  }
  /deep/ .el-input__inner {
    width: 16.25rem;
    height: 2.5rem;
    background: #64999f27;
    border: 0.125rem solid #244447;
    border-radius: 0rem;
    color: #ffffff;
    font-size: 1rem !important;
  }
  /deep/ .el-form-item__label {
    color: #fff;
    font-size: 1rem !important;
  }
}


.btn-cancel {
  width: 8.125rem;
  height: 1.875rem;
  border-radius: 0.125rem;
  border: 0.0625rem solid #6c9cb5;
  background: transparent;
  color: white;
  font-size: 0.875rem;
  cursor: pointer;
}
.btn-cancel:hover {
  background: #124f55;
}
.titleBox {
  display: flex;
  align-items: center;
  margin: 0.8125rem 0rem 0rem 1.5rem;
  border-left: 1px rgb(68, 215, 182) solid;

  span {
    width: 6.25rem;
    height: 1rem;
    font-size: 1rem;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: rgb(68, 215, 182);
    line-height: 1.125rem;
    padding-left: 1.25rem;
  }
}

.btn3 {
  width: 8.125rem;
  height: 1.875rem;
  background: #219E82;
  border-radius: 0.125rem;
  border: 0.0625rem solid #219E82;
  color: white;
  font-size: 0.875rem;
  cursor: pointer;
  margin: 1.875rem 1.25rem;
}
.btn3:hover {
  background: #44D7B6;
}

.btn3:disabled {
  cursor: not-allowed;
  background: #325f63;
}
.btn4 {
  width: 8.125rem;
  height: 1.875rem;
  border-radius: 0.125rem;
  border: 0.0625rem solid #44D7B6;
  background: transparent;
  color: #44D7B6;
  font-size: 0.875rem;
  cursor: pointer;
  margin: 1.875rem 1.25rem;
}
.btn4:hover {
  background: #44D7B655;
}

@media screen and (max-width: 1440px) {
  .titleBox {
    display: flex;
    align-items: center;
    margin: 13px 0px 0px 24px;
    border-left: 1px rgb(68, 215, 182) solid;

    span {
      width: 100px;
      height: 16px;
      font-size: 16px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: rgb(68, 215, 182);
      line-height: 18px;
      padding-left: 20px;
    }
  }
}
</style>
  


// WEBPACK FOOTER //
// src/pages/systemSet/passwdSet/index.vue